import { http } from 'config';

import {
  GET_CHARGE_POINTS_POWER_BY_GRID_CONNECTION_ID_URL,
  GET_ELECTRICITY_METERS_POWER_BY_GRID_CONNECTION_ID_URL,
  GRID_CONNECTIONS_BY_ID_URL,
  GRID_CONNECTIONS_URL,
} from './endpoints';

export const getGridConnectionMetersPower = async (gridConnectionId: number) =>
  await http.get<{ power: string }>(
    GET_ELECTRICITY_METERS_POWER_BY_GRID_CONNECTION_ID_URL(gridConnectionId)
  );

export const getGridConnectionChargersPower = async (gridConnectionId: number) =>
  await http.get<{ task_result: string }>(
    GET_CHARGE_POINTS_POWER_BY_GRID_CONNECTION_ID_URL(gridConnectionId)
  );

// ? Duplicated but why? Not used anyway
export const getGridConnectionPower = async (gridConnectionId: number) =>
  await http.get<{ power: string }>(
    GET_ELECTRICITY_METERS_POWER_BY_GRID_CONNECTION_ID_URL(gridConnectionId)
  );

export const getGridConnections = async (pageSize = 999) =>
  await http.get(GRID_CONNECTIONS_URL, {
    params: { page_size: pageSize },
  });

export const getGridConnectionById = async (gridConnectionId: number) =>
  await http.get(GRID_CONNECTIONS_BY_ID_URL(gridConnectionId));
